import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosAuth } from "../config/axiosInstance";
import { PERSONALISED_VIDEO_PLAYER_BACKEND_BASE_URL } from "../config/api_config";
import { resolveCourseId, resolveModuleSlug } from "../utilities/videoPlayerApi";

export const fetchUserActivityUpdate = createAsyncThunk(
    'userActivityUpdate/fetchUserActivityUpdate',
    async ({ course_id, module_slug, lesson_id, status }, { getState }) => {
        const courseId = resolveCourseId(getState(), course_id);
        const moduleSlug = resolveModuleSlug(module_slug);
        const response = await axiosAuth.patch(
            `${PERSONALISED_VIDEO_PLAYER_BACKEND_BASE_URL}/api/v1/courses/${courseId}/modules/${moduleSlug}/lessons/${lesson_id}`,
            { status }
        );
        return response.data;
    }
);

const updateUserActivitySlice = createSlice({
    name: 'updateUserActivity',
    initialState: {},
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchUserActivityUpdate.fulfilled, (state, action) => action.payload);
    },
});

export default updateUserActivitySlice.reducer;
